// Fine-grained navigation status for a (sub-)page menu entry.

export const STEP_STATUS = {
    ACTIVE: 'active',
    VALID: 'valid',
    INVALID: 'invalid',
    PENDING: 'pending'
}

// Icon + utility class per status. The active entry always wins so the user can see where
// they are; a touched-but-invalid entry is flagged with a warning so the offending page is
// obvious at a glance.
export const STEP_STATUS_ICON = {
    [STEP_STATUS.ACTIVE]:  {icon: ['fas', 'circle-dot'], className: 'text-primary'},
    [STEP_STATUS.VALID]:   {icon: ['fas', 'check-circle'], className: 'text-success'},
    [STEP_STATUS.INVALID]: {icon: ['fas', 'exclamation-triangle'], className: 'text-warning'},
    [STEP_STATUS.PENDING]: {icon: ['far', 'circle'], className: 'text-muted'}
}

// `validationState` is the store's `stepsValidationState`: true (valid), false (touched but
// invalid), or undefined (not yet visited).
export function resolveStepStatus(step, activeKey, validationState) {
    if (step.key === activeKey) return STEP_STATUS.ACTIVE
    const validity = validationState[step.key]
    if (validity === true) return STEP_STATUS.VALID
    if (validity === false) return STEP_STATUS.INVALID
    return STEP_STATUS.PENDING
}
